import React from 'react'
import { Socket } from 'phoenix'
import Chat from '@botsquad/web-client'
import { NotificationManager } from '@botsquad/web-client'

import ChatHeader from './ChatHeader'
import { newGroup, consumeChannelParams } from '../common/util'
import { localePreflist } from '../common/labels'
import { MAPS_API_KEY } from '../utils'

export default class EmbeddedApp extends React.Component {
  state = {
    g: newGroup(),
    hide_input: false,
    online: true,
    settings: {},
  }

  UNSAFE_componentWillMount() {
    this.setState({ settings: this.props.settings })

    const heartbeatIntervalMs = 5000
    this.socket = new Socket(this.props.socket, { reconnectAfterMs: () => 1000, heartbeatIntervalMs })
    this.socket.onOpen(() => {
      this.handleOnlineStatus({ type: 'online' })
    })
    this.socket.onError(() => {
      this.socket.channels.forEach(ch => {
        const params = ch.params()
        ch.params = () => ({ ...params, reconnect: true })
        ch.joinPush.payload = ch.params
      })
    })
    this.socket.onClose(() => this.handleOnlineStatus({ type: 'offline' }))
    this.socket.connect()

    window.addEventListener('online', this.handleOnlineStatus.bind(this))
    window.addEventListener('offline', this.handleOnlineStatus.bind(this))
  }

  componentWillUnmount() {
    this.socket.disconnect()
    window.removeEventListener('online', this.handleOnlineStatus.bind(this))
    window.removeEventListener('offline', this.handleOnlineStatus.bind(this))
  }

  handleMessage(name, data) {
    if (!this.chat) return
    switch (name) {
      case 'getLastEmitted':
        return this.chat.state.events
          .concat([])
          .reverse()
          .find(c => c.type === 'emit' && c.payload.event === data)
      case 'message':
        this.chat.handler.send('message', data)
        break
      case 'location':
        this.chat.handler.send('location', data)
        break
      case 'media':
        this.chat.handler.send('attachment', data)
        break
      case 'event':
        this.chat.handler.send('event', data)
        break
      case 'focus':
        if (data && document.querySelector('input')) {
          document.querySelector('input').focus()
        }
        break
      case 'settings':
        this.setState({ settings: data })
        break
    }
  }

  config(key, value) {
    this.props.host.config(key, value)
  }

  handleOnlineStatus(event) {
    const online = event.type === 'online'
    this.setState({ online })
  }

  onClose = () => {
    this.props.host.close()
  }

  closeConversation = () => {
    this.setState({ g: newGroup(), hide_input: false })
  }

  render() {
    if (!this.socket) {
      this.handleOnlineStatus({ type: 'offline' })
    }
    const { host, params } = this.props
    const { hide_input } = this.state

    params.g = this.state.g

    return (
      <>
        <ChatHeader {...this.props} onClose={this.onClose} />
        <Chat
          key={params.g}
          {...this.props}
          {...this.state}
          onHideInput={hide_input => this.setState({ hide_input })}
          settings={{ ...this.props.settings, hide_input }}
          mapsApiKey={MAPS_API_KEY}
          frame={this}
          closeConversation={this.closeConversation}
          onEmit={({ event, payload }) => {
            host._triggerCallback('emit', event, payload)
          }}
          onEvent={({ event, payload }) => {
            host._triggerCallback('event', event, payload)
          }}
          onReady={host._onReady}
          onChannel={channel => {
            const manager = new NotificationManager(this)
            manager.componentDidMount()
            manager.setChannel(channel)
            channel.on('conversation_meta', meta => {
              manager.notifyMessageCount(meta.unread_message_count)
            })

            consumeChannelParams()
          }}
          socket={this.socket}
          localePrefs={localePreflist(this.props.locale, this.props.bot)}
          onClose={this.onClose}
        />
      </>
    )
  }
}
